import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import Container from "@mui/material/Container";
import MuiLink from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CategoriesRegistrationStatus from "./components/CategoriesRegistrationStatus.jsx";

const Validation = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;

    const { t } = i18n;
    const location = useLocation();
    const navigate = useNavigate();

    const state = location.state;

    const [loading, setLoading] = useState(false);

    const [entries, setEntries] = useState([]);
    const [rejected, setRejected] = useState([]);
    // Sent back by the registration endpoint; absent when the competition takes
    // no online payments, and then there is nothing to link to.
    const [paymentLink, setPaymentLink] = useState(null);
    // What a reserve-list offer needs to send: whose entry, and the dances chosen for
    // single-dance categories.
    const [uuid, setUuid] = useState(null);
    const [selectedDances, setSelectedDances] = useState({});


    useEffect(() => {
        if (state === null) {
            navigate("/");
        } else {
            setLoading(true);
            let tmpUuid = "";
            setEntries(state.entries);
            setRejected(state.rejected);
            setPaymentLink(state.paymentLink || null);
            setUuid(state.uuid || null);
            setSelectedDances(state.selectedDances || {});
        }
    }, [state]);

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.validation")}</h2>
            <p>{t("reg.info.validation")}</p>

            {/* <div className="d-flex flex-wrap p-2 justify-content-center"> */}
            <Container maxWidth="xs" className="mb-2">
                {/* {fetched && <CategoriesRegistrationStatus entries={entries} rejected={rejected} t={t} />} */}
                <CategoriesRegistrationStatus
                    entries={entries}
                    rejected={rejected}
                    t={t}
                    uuid={uuid}
                    api={itemOptions ? itemOptions.api : undefined}
                    selectedDances={selectedDances}
                />

                <Stack spacing={1}>
                    {paymentLink && (
                        <MuiLink href={paymentLink} target="_self" underline="none">
                            <Button color="warning" variant="contained" fullWidth startIcon={<CreditCardIcon />}>
                                {t("go_to_payment")}
                            </Button>
                        </MuiLink>
                    )}
                    <Link to="/">
                        <Button variant="contained" fullWidth>
                            {t("reg.back_to_home")}
                        </Button>
                    </Link>
                </Stack>
            </Container>
            {/* </div> */}
        </React.Fragment>
    );
};

export default Validation;
